module.exports = "table {\n  border-collapse: inherit !important;\n}\n\n.ratecheck {\n  background-color: white;\n  padding: 5px;\n  border-radius: 10px;\n}"